import { FamilyChildProfile, FamilyParentProfile } from "@joonapp/web-shared"
import { create } from "zustand"

import { QuestionnaireAnswersResponse } from "../../../types"

interface SurveysModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void

  selectedSurvey: QuestionnaireAnswersResponse | null
  selectedChildSurveys: QuestionnaireAnswersResponse[]
  selectedProfile: FamilyChildProfile | FamilyParentProfile | null
  selectSurvey: (survey: {
    survey: QuestionnaireAnswersResponse
    profile: FamilyChildProfile | FamilyParentProfile
  }) => void
  selectChildSurveys: (surveys: {
    surveys: QuestionnaireAnswersResponse[]
    profile: FamilyChildProfile
  }) => void
  clearSurvey: () => void
}

const initialData = {
  isOpen: false,
  selectedSurvey: null,
  selectedChildSurveys: [],
  selectedProfile: null,
}

const useSurveysModalStore = create<SurveysModalStore>((set) => ({
  ...initialData,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set(initialData),

  selectSurvey: ({ survey, profile }) =>
    set({ selectedSurvey: survey, selectedProfile: profile }),
  selectChildSurveys: ({ surveys, profile }) =>
    set({ selectedChildSurveys: surveys, selectedProfile: profile }),
  clearSurvey: () =>
    set({
      selectedSurvey: null,
      selectedChildSurveys: [],
      selectedProfile: null,
    }),
}))

export default useSurveysModalStore
